import { async } from 'q';
import { createStore, createLogger } from 'vuex'; 
import createPersistedState from 'vuex-persistedstate';

export default createStore({
    //plugins: [createPersistedState(), createLogger()],
    plugins: [createPersistedState()],
    state: {
        token: null,
        expiration: null,
        role: null,
        language: "en",
        captchaCount: 0
    },
    mutations: {
        setToken: (state, model) => {
            state.captchaCount = 0;
            state.token = model.user_data;
            state.expiration = model.token_expiry;

            if (state.token.Language != null) {
                state.language = state.token.Language;
            }

            //state.expiration = new Date()
        },
        clearToken: (state) => {
            state.token = null;
            state.expiration = null;
            //state.expiration = Date.now();
        },
        setRole: (state, model) =>{
            state.role = model;
        },
        setLanguage: (state, model)=>{
            state.language = model;
        },
        setCaptchaCount: (state) => {
            state.captchaCount++;
        }
    },
    getters: {
        isAuthenticated: (state) => {
            var currentToken = state.token;
            if (currentToken) {
                return true;
            }
            else return false;

            //return state.token != "" && state.expiration > Date.now();
        },
        authorizedMenu: (state) => {
            if (state.token) {
                return state.token.Menus;
            }
            else return null;
        },
        isExpired: (state) => {
            var currentToken = state.token;

            if (currentToken) {
                if (new Date(state.expiration) <= new Date()) {
                    return true;
                }
                else return false;
            } else return false;
        },
        getUsername: (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Employee_Number;
            }
            else return "";
        },
         getFullname: (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Full_Name;
            }
            else return "";
        },
        getPICname : (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.PIC_Name;
            }
            else return "";
        },
        getIsAdmin :(state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Is_Admin;
            }
            else return false;
        },
        getUseAD: (state) => {
            var currentToken = state.token;

            if(currentToken){
                return currentToken.Use_AD;
            }
            else return false;
        },
        getServer: (state) => {
            var currentToken = state.token;

            if(currentToken){
                return currentToken.SERVER;
            }
            else return "";
        },        
        getLanguage: (state) =>{
            return state.language;
        },
        getMenu: (state) => {
            return state.token ? state.token.Menus : [];
        },
        getCaptchaCount: (state) => {
            return state.captchaCount;
        },
        getPeriorYear: (state) => {
            var currentToken = state.token;

            if(currentToken){
                return currentToken.Period_Year;
            }
            else return 0;
        },
        getAccount: (state) => {
            var currentToken = state.token;

            if(currentToken){
                return currentToken.Account;
            }
            else return 0;
        },
        getUserLevel : (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.User_Level;
            }
            else return "";
        },
        getJobPosition : (state) => {
            var currentToken = state.token;

            return currentToken ? currentToken.Job_Postion : [];
        },
        getListTransactionCreate : (state) => {
            var currentToken = state.token;

            return currentToken ? currentToken.getListTransactionCreate : [];
        },
        getListTransactionEdit : (state) => {
            var currentToken = state.token;

            return currentToken ? currentToken.getListTransactionEdit : [];
        },
        getListTransactionPrint : (state) => {
            var currentToken = state.token;

            return currentToken ? currentToken.getListTransactionPrint : [];
        },
        getListTransactionView : (state) => {
            var currentToken = state.token;

            return currentToken ? currentToken.getListTransactionView : [];
        },
        getIsContractor: (state) =>{
            var currentToken = state.token;
            var isContractor = currentToken.Job_Postion.includes("CONTRACTOR") || currentToken.Job_Postion.includes("ADMIN CONTRACTOR") || currentToken.Job_Postion.includes("PROJECT MANAGER CONTRACTOR");
            return isContractor;
        },
        getLocation : (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Location_Code;
            }
            else return "";
        },
        getUrlApp:(state)=>{
            var currentToken = state.token;
            if (currentToken) {
                return currentToken.url_app;
            }
            else return "";
        },
        getDepartmentWo : (state) => {
            var currentToken = state.token;

            if (currentToken) {
                return currentToken.Department_Code_Wo;
            }
            else return "";
        },
        getIsAdministrator: (state) =>{
            var currentToken = state.token;
            var IsAdministrator = currentToken.Is_Administrator;
            return IsAdministrator;
        },        
        getRole : (state) => {
            var currentToken = state.token;

            return currentToken ? currentToken.Role : "";
        },
        getIsHaveRelease : (state) =>{
            var currentToken = state.token;
            var result = currentToken.haveRelease;
            return result;
        },    
        getAddHoursGMT : (state) =>{
            var currentToken = state.token;
            if(currentToken){
                return currentToken.addHourGmt;
            }
            else return "";
        },    
        getIsUpdateWo : (state) =>{
            var currentToken = state.token;
            var result = currentToken.isupdatewo == "1";
            return result;
        },   
    },
    actions: {
        login: async ({ commit }, data) => {
            commit("setToken", data);
        },
        logout: async ({ commit }) => {
            commit("clearToken");
        },
        role: async ({ commit }, data) => {
            commit("setRole", data);
        },
        language: async({commit}, data) =>{
            commit("setLanguage", data);
        },
        menu: async({commit}, data) => {
            commit("setMenu", data);
        },
        setCaptchaCount: async({commit}) => {
            commit("setCaptchaCount");
        }
    }
});

// function checkRole(state, role){
//     var currentToken = state.token;

//     if (currentToken) {
//         if(currentToken.Is_Admin) return true;
//         else return currentToken.Role == role;
//     }

//     else return false;
// }